import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type {
  TrainingVm,
  TrainingListItem,
  TrainingListResponse,
} from '@/api/types/training.types'

export class TrainingService {
  async getAll(branchId: number, pageNumber: number = 1, pageSize: number = 1000): Promise<TrainingListResponse> {
    const url = endpoints.training.getAll(branchId, pageNumber, pageSize)
    console.log('[Training] GET_ALL request:', { url, branchId, pageNumber, pageSize })
    const res = await apiClient.get<TrainingListResponse | TrainingListItem[] | { data: TrainingListItem[] }>(url)
    const raw = res.data as any
    if (raw && Array.isArray(raw.data)) {
      console.log('[Training] GET_ALL response:', { totalRecords: raw.totalRecords, count: raw.data.length })
      return {
        data: raw.data,
        totalRecords: raw.totalRecords ?? raw.data.length ?? 0,
        pageNumber: 1,
        pageSize: raw.data.length,
      }
    }
    if (Array.isArray(raw)) {
      return {
        data: raw as TrainingListItem[],
        totalRecords: (raw as TrainingListItem[]).length,
        pageNumber: 1,
        pageSize: (raw as TrainingListItem[]).length,
      }
    }
    return { data: [], totalRecords: 0, pageNumber: 1, pageSize: 0 }
  }

  async getById(id: number): Promise<TrainingVm> {
    const url = endpoints.training.getById(id)
    const res = await apiClient.get<TrainingVm | { data: TrainingVm }>(url)
    const raw = res.data as any
    if (raw && typeof raw === 'object' && 'data' in raw) return raw.data as TrainingVm
    return raw as TrainingVm
  }

  async getByEmpId(empId: number): Promise<TrainingListItem[]> {
    const url = endpoints.training.getByEmpId(empId)
    const res = await apiClient.get<TrainingListItem[] | { data: TrainingListItem[] }>(url)
    const raw = res.data as any
    if (Array.isArray(raw)) return raw as TrainingListItem[]
    if (raw && typeof raw === 'object' && 'data' in raw && Array.isArray(raw.data)) {
      return raw.data as TrainingListItem[]
    }
    return []
  }

  async save(payload: TrainingVm): Promise<unknown> {
    const url = endpoints.training.save
    console.log('[Training] SAVE payload:', { url, payload })
    const res = await apiClient.post(url, payload)
    console.log('[Training] SAVE response:', res.data)
    return res.data
  }

  async update(payload: TrainingVm): Promise<unknown> {
    const url = endpoints.training.update
    console.log('[Training] UPDATE payload:', { url, payload })
    const res = await apiClient.put(url, payload)
    console.log('[Training] UPDATE response:', res.data)
    return res.data
  }

  async delete(id: number): Promise<void> {
    const url = endpoints.training.delete(id)
    await apiClient.delete(url)
  }
}

export const trainingService = new TrainingService()
